export default __webpack_public_path__ + "static/media/Aircraft6-t.b0dc9545.png";